import Vue from 'vue';
import Vuex from 'vuex';

import activity from './modules/activity';
import auth from './modules/auth';


Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        activity,
        auth,
    },
});

export default store;
